// extracted by mini-css-extract-plugin
export default {"root":"ProfitStatus_root__GgZdM","secondTitle":"ProfitStatus_secondTitle__jmDEB","gradient":"ProfitStatus_gradient__8BLrF","yellow":"ProfitStatus_yellow__p0Mr6"};